import colors from '../../../config/theme/colors';

export const badgeSX = (alternate?: boolean) => ({
  '& .MuiBadge-badge': {
    xs: {
      right: -2,
      top: 3,
      border: alternate ? '1px solid ' + colors.appBlue.light : 'none',
    },
    md: {
      right: 2,
      top: -6,
      border: alternate ? '1px solid ' + colors.appBlue.light : 'none',
    },
  },
});
